// Login.js
import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { login, error: authError, fetchWithRetry } = useAuth(); // Thêm fetchWithRetry

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await fetchWithRetry({
        method: "post",
        url: "/api/users/login",
        data: { email, password },
      });
      console.log("Login response:", res.data);

      // Kiểm tra token và user trong phản hồi
      const token = res.data.token || res.data.accessToken;
      const user = res.data.user;

      if (!token || !user) {
        console.error("Phản hồi API thiếu token hoặc user:", res.data);
        setError("Đăng nhập thất bại. Không nhận được token hoặc thông tin người dùng. Vui lòng thử lại!");
        return;
      }

      const userRole = user.role;
      console.log("User role after login:", userRole);

      if (!userRole) {
        setError(`Vai trò của bạn (${userRole || "không xác định"}) không hợp lệ. Vui lòng liên hệ quản trị viên!`);
        return;
      }

      // Gọi hàm login từ AuthContext
      login(user, token, res.data.refreshToken || localStorage.getItem("refreshToken"));

      // Điều hướng dựa trên vai trò
      if (userRole === "admin" || userRole === "mod") {
        navigate("/admindashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      console.error("Lỗi đăng nhập:", err);
      const errorMessage =
        err.response?.data?.message ||
        (err.response?.status === 401
          ? "Sai email hoặc mật khẩu!"
          : "Lỗi kết nối server. Vui lòng thử lại!");
      setError(errorMessage);
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100 font-sans">
      <div className="p-8 max-w-md w-full bg-white rounded-lg shadow-xl">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Đăng nhập</h2>
        {(error || authError) && (
          <p className="text-red-500 text-center mb-4">{error || authError}</p>
        )}

        <form onSubmit={handleLogin} className="space-y-4">
          <input
            type="email"
            placeholder="Email"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            type="password"
            placeholder="Mật khẩu"
            className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-400"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <button
            type="submit"
            className="w-full bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 transition duration-200"
          >
            Đăng nhập
          </button>
        </form>

        <div className="flex justify-between mt-4 text-sm">
          <Link to="/forgot-password" className="text-green-500 hover:underline">
            Quên mật khẩu?
          </Link>
          <Link to="/register" className="text-green-500 hover:underline">
            Đăng ký tài khoản
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Login;